import type {
  AttendanceContextType,
  AttendanceRecordResponse,
  CheckInRequest,
  PaginatedResponse,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export interface ListAttendanceParams {
  readonly personId?: string | undefined;
  readonly contextType?: AttendanceContextType | undefined;
  readonly contextId?: string | undefined;
  readonly openOnly?: boolean | undefined;
  readonly limit?: number | undefined;
}

export const attendanceApi = {
  list(params: ListAttendanceParams = {}, signal?: AbortSignal) {
    return apiRequest<PaginatedResponse<AttendanceRecordResponse>>('/attendance', {
      query: { ...params },
      signal,
    });
  },

  checkIn(body: CheckInRequest) {
    return apiRequest<AttendanceRecordResponse>('/attendance', { method: 'POST', body });
  },

  /** There is no delete or archive. A mis-check-in is corrected by checking out. */
  checkOut(id: string) {
    return apiRequest<AttendanceRecordResponse>(`/attendance/${id}/check-out`, {
      method: 'POST',
    });
  },
};
